import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import { isValid } from "date-fns"
import format from "date-fns/format"
import React, { useCallback, useState } from "react"
import DatePicker from "react-date-picker"
import { UserPastRouteRecordsQueryVariables, useUserPastRouteRecordsQuery } from "../../graphql"
import { Card } from "../common"
import { UserRoutesList } from "./UserRoutesList"

export type UserPastRoutesProps = {
	userId: string
}

export const UserPastRoutes: React.FC<UserPastRoutesProps> = ({ userId }) => {
	const [date, setDate] = useState(new Date(format(new Date(), "MM/dd/yyyy")))
	const [pagination, setPagination] = useState<UserPastRouteRecordsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useUserPastRouteRecordsQuery({ variables: { userId, pagination, date } })

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.userPastRouteRecords.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<Card title="Past Routes" alwaysShowAction action={<DatePicker onChange={(value) => isValid(value) && setDate(value as Date)} value={date} format="MMM dd, y" maxDate={new Date()} clearIcon={null} />}>
			{fetching && !data?.userPastRouteRecords ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading past routes</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.userPastRouteRecords.userRouteRecords.length ? (
				<VStack w="full" align="stretch">
					<UserRoutesList userRouteRecords={data.userPastRouteRecords.userRouteRecords} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more records</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="md" color="error.500">
						Couldn&apos;t find past routes
					</Text>
				</Center>
			)}
		</Card>
	)
}
